export default "/dist/files/icon_mur_echanges.18af0624cfa60970b067b3a6b3a27455.svg";